import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaWhatsapp, FaTelegramPlane } from 'react-icons/fa';
import PaymentMethods from './PaymentMethods';
import { SiteFeatures } from 'config/siteFeatures';

const Footer = () => {
  const { t } = useTranslation();
  
  // İletişim numarası - Buraya WhatsApp ve Telegram numaranızı ekleyin
  // WhatsApp için: Ülke kodu ile birlikte, + işareti olmadan (örn: 905551234567)
  // Telegram için: Kullanıcı adı veya numara (örn: username veya +905551234567)
  const whatsappNumber = '+9647505996005'; // Buraya WhatsApp numaranızı girin
  const telegramUsername = '+009647505996005'; // Buraya Telegram kullanıcı adınızı veya numaranızı girin
  // WhatsApp için numarayı temizle: + ve 00'ı kaldır, sadece rakamları bırak
  const cleanWhatsAppNumber = whatsappNumber.replace(/^\+?0*/, '').replace(/\D/g, '');
  
  const handleWhatsAppClick = () => {
    window.open(`https://wa.me/${cleanWhatsAppNumber}`, '_blank');
  };
  
  const handleTelegramClick = () => {
    // Telegram için: Eğer sadece rakamlardan oluşuyorsa (numara), + ile birlikte kullan
    // Aksi halde kullanıcı adı olarak kabul et
    const cleaned = telegramUsername.replace(/^\+?0*/, '');
    if (/^[\d\s\-\(\)]+$/.test(cleaned)) {
      // Sadece rakam, boşluk, tire, parantez içeriyorsa numara olarak kabul et
      const cleanNumber = cleaned.replace(/\D/g, '');
      window.open(`https://t.me/+${cleanNumber}`, '_blank');
    } else {
      // Kullanıcı adı ise direkt kullan
      window.open(`https://t.me/${cleaned}`, '_blank');
    }
  };
  
  return (
    <footer className="mt-12 pb-0 bg-secondary-900/20 backdrop-blur-sm relative z-30">
    <div className="px-0 max-w-screen-lg mx-auto">
      {/* Ana Footer İçeriği */}
      <div className="   p-6 mb-0">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
           {/* ÖDEME YÖNTEMLERİ Bölümü */}
          {SiteFeatures.DEPOSIT_SYSTEM && (
            <div className="text-center md:text-left">
              <h3 className="text-white text-lg font-bold mb-4 pb-2 border-b border-primary-500/30">
                {t("FOOTER_PAYMENT_METHODS")}
              </h3>
              <PaymentMethods />
            </div>
          )}
          {/* HAKKINDA Bölümü */}
          <div className="text-center md:text-left">
            <h3 className="text-white text-lg font-bold mb-4 pb-2 border-b border-primary-500/30">
              {t("FOOTER_ABOUT")}
            </h3>
            <div className="flex flex-wrap gap-x-4 gap-y-2 justify-center md:justify-start">
              <a href="#" className="text-gray-300 hover:text-primary-400 transition-colors duration-200 text-sm whitespace-nowrap">
                {t("FOOTER_TERMS_CONDITIONS")}
              </a>
              <a href="#" className="text-gray-300 hover:text-primary-400 transition-colors duration-200 text-sm whitespace-nowrap">
                {t("FOOTER_PRIVACY_POLICY")}
              </a>
              <a href="#" className="text-gray-300 hover:text-primary-400 transition-colors duration-200 text-sm whitespace-nowrap">
                {t("FOOTER_RGA_GT_C")}
              </a>
              <a href="#" className="text-gray-300 hover:text-primary-400 transition-colors duration-200 text-sm whitespace-nowrap">
                {t("FOOTER_AML_POLICY")}
              </a>
              <a href="#" className="text-gray-300 hover:text-primary-400 transition-colors duration-200 text-sm whitespace-nowrap">
                {t("FOOTER_KYC")}
              </a>
            </div>
          </div>

          {/* YARDIM Bölümü */}
          <div className="text-center md:text-left">
            <h3 className="text-white text-lg font-bold mb-4 pb-2 border-b border-primary-500/30">
              {t("FOOTER_HELP")}
            </h3>
            <div className="flex flex-wrap gap-x-4 gap-y-2 justify-center md:justify-start">
              <a href="#" className="text-gray-300 hover:text-primary-400 transition-colors duration-200 text-sm whitespace-nowrap">
                {t("FOOTER_SPORTS_BETTING")}
              </a>
              <a href="#" className="text-gray-300 hover:text-primary-400 transition-colors duration-200 text-sm whitespace-nowrap">
                {t("FOOTER_FAQ")}
              </a>
              <a href="#" className="text-gray-300 hover:text-primary-400 transition-colors duration-200 text-sm whitespace-nowrap">
                {t("FOOTER_CASINO")}
              </a>
              <a href="/contact-us" className="text-gray-300 hover:text-primary-400 transition-colors duration-200 text-sm whitespace-nowrap">
                {t("FOOTER_CONTACT_US")}
              </a>
            </div>
          </div>

         

              <div className="text-center md:text-left">
            <div className="flex gap-2 justify-center md:justify-start">
              <button
                onClick={handleWhatsAppClick}
                className="flex items-center justify-center w-10 h-10 text-white bg-[#25D366] hover:opacity-90 rounded-full transition-opacity duration-200"
                aria-label="WhatsApp"
              >
                <FaWhatsapp className="text-xl" />
              </button>
              
            </div>
          </div>
     
        </div>
      </div>

      {/* Alt Footer - Copyright */}
      <div className="text-center">
        <div className=" rounded-lg py-4 px-6">
          <p className="text-gray-400 text-sm">
            {t("FOOTER_COPYRIGHT", { company: "KurdBetDax" })}
          </p>
          <p className="text-gray-500 text-xs mt-1">
            {t("FOOTER_RESPONSIBLE_GAMING")}
          </p>
        </div>
      </div>
      
      {/* BottomNavigation için mesafe
      <div className="h-16 mobile-show"></div> */}
    </div>
  </footer>
  );
};

export default Footer;
